<template>
<div class="form-v2">

  <h3 class="sub_t p-flex">Antecedentes generales</h3>
  <v-layout wrap>
    <value_container label="Nombre del BCEI" :value="selectedItem.critical_asset_name" md="12"/>
    <value_container label="Organización" :value="selectedItem.critical_asset_organization" md="4"/>
    <value_container label="Áreas Impactadas" :value="selectedItem.critical_asset_impacted_areas_names" md="4"/>

    <value_container md="4" label="TAG Equipo" :value="selectedItem.critical_asset_tag"/>
    <value_container md="4" label="Functional Location" :value="selectedItem.functional_location"/>
    <value_container md="4" label="Riesgo Material" :value="selectedItem.critical_asset_bowtie_name"/>

    <value_container md="4" label="Estándar" :value="selectedItem.critical_asset_standards_name"/>
    <value_container :value.sync="selectedItem.creation_date" label="Fecha de Creación" md="4"/>
    <value_container md="4" label="Fecha de inspección" :value="selectedItem.inspection_date"/>

    <value_container :value.sync="selectedItem.sap_notice_inspection_number" label="N° Aviso de Inspección 1SAP" md="4"/>
    <value_container :value.sync="selectedItem.sap_ot_inspection_number" label="N° OT de Inspeccion 1SAP" md="4"/>
    <value_container :value.sync="selectedItem.technical_report" label="Hallazgo Identificado mediante" md="4"/>

    <value_container md="4" label="Sector Inspeccionado" :value="selectedItem.inspection_place"/>
    <value_container :value.sync="selectedItem.notebook_code" label="Código PED" md="4"/>
    <value_container md="4" label="Especialidad" :value="speciality_name(selectedItem.speciality)"/>
    
    <value_container md="4" label="Creador de Hallazgo" :value="selectedItem.owner_name"/>
    <value_container :value.sync="selectedItem.finding_code" label="Código" md="4"/>
  </v-layout>
  <value_container label="Descripción del hallazgo identificado" :value="selectedItem.description"/>
      <template v-if="has_geo_location">
      <v-layout>
        <v-flex>
          <fs1 tag="h2">Ubicación Geográfica (Lat: {{ map_marker_pos.lat }}, Lng: {{ map_marker_pos.lng }})</fs1>
        </v-flex>
      </v-layout>

      <v-layout style="align-items: center;">
        <in-num :text="map_marker_pos.lat" label="Latitud" md="4" :float="true" :min="null" :step="1/1000" :disabled="true"/>
        <in-num :text="map_marker_pos.lng" label="Longitud" md="4" :float="true" :min="null" :step="1/1000" :disabled="true"/>
        <!-- <v-flex md4 style="text-align: right;">
          <v-btn color="primary" outlined @click="Object.assign(map_pos_cen,map_pos)">
            <v-icon>location_on</v-icon>
            <span>Centrar</span>
          </v-btn>
          <v-btn color="primary" outlined @click="Object.assign(map_pos,map_pos_cen_def)">
            <v-icon>cached</v-icon>
            <span>Restaurar</span>
          </v-btn>
        </v-flex> -->
      </v-layout>

      <v-layout>
        <v-flex>
          <GmapMap
            :center="map_pos_cen"
            :zoom="12"
            map-type-id="hybrid"
            style=" height: 450px"
            :options="{mapId:'3901562e286aae9f35e1081f'}">
            <GmapMarker
              :position="map_marker_pos"
              :clickable="false"
              :draggable="false"/>
          </GmapMap>
        </v-flex>
      </v-layout>
      </template>
  <h3 class="sub_t p-flex">Tipo de Impacto y Calculo de Prioridad</h3>
  <v-layout>
    <value_container md="4" label="Tipo de Impacto" :value="impact_name == 'Legal'? 'Reputación / Legal':impact_name"/>
  </v-layout>

  <v-layout v-if="selectedItem.impact_type === 'financial'">
    <value_container md="4" label="Áreas Impactadas" :value="selectedItem.critical_asset_impacted_areas_names"/>
    <value_container md="4" label="Porcentaje de Impacto" :value="impact_percentage"/>
    <value_container md="4" label="EBITDA Hallazgo" :value="selectedItem.ebit"/>
  </v-layout>
  <div>
    <v-layout v-if="selectedItem.impact_type === 'financial'">
      <v-flex md8 class="form-v1">
        <v-layout class="a1a">
          <v-flex md6><fs1 tag="div">Días de detención</fs1></v-flex>
          <v-flex md6><fs1 tag="div">Pérdida Financiera en MUSD del hallazgo identificado</fs1></v-flex>
        </v-layout>
        <v-layout class="a1b">
          <value_container md="6" :value="selectedItem.mfl_days"/>
          <value_container md="6" :value="selectedItem.computed_financial_mfl"/>
        </v-layout>
      </v-flex>
      <v-flex md4>
        <MflsValues_rev :asset="selectedItem" :set="()=>dialogMfl=true" :mfls="['mfl_financial']"/>
      </v-flex>

      <!-- <v-flex md4 style="padding: 0 !important;">
        
      </v-flex> -->
    </v-layout>
  </div>


  <v-layout v-if="mfl_can_edit">
    <v-flex md4 style="padding: 0 !important;">
      <MflsValues_rev :asset="selectedItem" :set="()=>dialogMfl=true" :mfls="[selected_mfl_key]"/>
    </v-flex>
  </v-layout>

  <v-layout>
    <Likelihood :value.sync="selectedItem.likelihood" :disabled="true" md="4"/>
    <v-flex md4>
      <b>Priority</b>
      <div class="p_box" :class="[p_color,dark_t?'dark':'']" @click="()=>priority_dialog=true">{{selectedItem.priority}}</div>
    </v-flex>
  </v-layout>
  <template v-if="!simulation">
    <div class="p-flex" v-if="selectedItem.finding_code && !re_inspect">
      <h3 class="sub_t">Listado de inspecciones anteriores</h3>
      <table_reinspec
        :items="selectedItem.inspection_dates"
        :disable_edit="true"
        :global_risk_standard_version="selectedItem.global_risk_standard_version"/>
    </div>
    <h3 class="sub_t p-flex">Comentarios<!-- Recomendaciones --></h3>
    <value_container :value="selectedItem.comment"/>
    <div v-if="!re_inspect && !selectedItem.documents.length" class="p-flex">
      <h3 class="sub_t">Documentos</h3>
      <fs1-div>Sin archivos</fs1-div>    
    </div>
    <div v-else class="p-flex">
      <template v-if="!re_inspect">
        <TableFiles :rows="selectedItem.documents" :disabled="true">
          <h3 class="sub_t">Documentos</h3>
        </TableFiles>
      </template>
    </div>

    <div class="p-flex" v-if="!re_inspect">
      <h3 class="sub_t">Registro fotográfico</h3>
      <fs1-div v-if="!selectedItem.photographic_record.length">Sin imagenes</fs1-div>
      <in_img v-else :container="selectedItem.photographic_record" c_key="picture" style="display: inline-block;" :multiple="true" :disabled="true"/>
      <br>
      <br>
      <!-- <h4>Responsable de la remediación</h4>
      <output_users :items="responsible"/> -->
  </div>
  </template>
  <priority_modal :item="selectedItem" :dialog.sync="priority_dialog" :edit="false" :x="p_x" :y="p_y"/>
</div>
</template>

<script>
import table_reinspec from '@/modules/CA_SP/components/actions/table_reinspec.vue';
import ModalMflTable from '@/components/modals/MflTable.vue';
import MflTableOld from '@/components/modals/MflTableOld.vue';
import MflsValues_rev from '@/modules/CA_SP/components/zz/MflsValues_rev.vue';
import value_container from '@/components/outputs/value_container.vue';
import TableFiles from '@/components/actions/table/files.vue';
import output_users from '@/components/actions/table/output_users.vue';
import Likelihood from '@/components/actions/Likelihood.vue';
import SXP from '@/components/actions/SXP.vue';
import in_img from '@/components/inputs/in-img.vue';
import { mapGetters } from 'vuex';
import priority_modal from '@/components/modals/priority.vue';
import { likelihood_values, priority_colors } from '@/objects/general.js';
import { getImpactTypes } from '@/objects/mfl_global_risk.js';
import { inpAreasNames } from '@/functions/general.js';
      /*  */const def_map_pos = {lat: -24.264548948399803, lng: -69.07323471840661};
export default {
  name:'view_action',
  props:['selectedItem','title','simulation','re_inspect'],
  components:{ in_img, TableFiles,SXP,Likelihood, output_users , value_container,MflsValues_rev,ModalMflTable,MflTableOld,priority_modal,table_reinspec },
  data() {
    return {
      /*  */
      map_pos_cen:{...def_map_pos},
      /*  */
      selected_ca:{},
      priority_colors,
      dialogMfl:false,
      priority_dialog:false,
      p_x:null,
      p_y:null,
    };
  },
  computed:{
    ...mapGetters({
      specialities: 'specialities',
      organizations: 'organizations',
    }),
    responsible(){ return this.selectedItem.responsible || [] },
    participants(){ return this.selectedItem.participants || [] },
    p_color(){ return this.priority_colors[this.selectedItem.priority] },
    organization_name(){ return (this.organizations.find(o=>o.id===this.selected_ca.organization)||{}).name},
    impacted_areas_names(){ return inpAreasNames(this.selected_ca.impacted_areas||[])},
    impact_percentage() { return this.selectedItem.impact_percentage === null ? this.selected_ca.impact_percentage: this.selectedItem.impact_percentage},
    //ebit() { return this.fix(this.selected_ca.ebit)},
    mfl_financial(){ return this.selected_ca.mfl_financial||''},
    selected_mfl_key(){ return `mfl_${this.selectedItem.impact_type}`},
    selectedItem_computed_financial_mfl_fixed(){return this.fix(this.selectedItem.computed_financial_mfl)},
    mfl_can_edit() {
      const editable = (this.selectedItem.global_risk_standard_version ?? 2) >= 2
        ? ['reputation', 'legal', 'sustainability', 'health_and_safety']
        : ['reputation', 'legal', 'community', 'environment', 'health_and_safety'];
      return editable.includes(this.selectedItem.impact_type);
    },
    impact_types(){ return getImpactTypes(this.selectedItem.global_risk_standard_version); },
    impact_name(){ return (this.impact_types.find(i=>i.id===this.selectedItem.impact_type) || {}).name || '' },
    has_geo_location() {
      const { lat, lng } = this.selectedItem;
      return lat != null && lng != null;
    },
    map_marker_pos() {
      return {
        lat: this.selectedItem.lat ?? def_map_pos.lat,
        lng: this.selectedItem.lng ?? def_map_pos.lng,
      };
    },
  },
  watch: {
    map_marker_pos: {
      immediate: true,
      handler(pos) { Object.assign(this.map_pos_cen, pos); },
    },
  },
  created(){
    this.dev_log('?',this.selectedItem,{likelihood_values},this.selectedItem[`mfl_${this.selectedItem.impact_type}`],this.selectedItem.likelihood);
    const x = this.selectedItem[`mfl_${this.selectedItem.impact_type}`] || 0;
    this.p_x = x>0?(x-1):undefined;
    likelihood_values.forEach((v,i)=>this.selectedItem.likelihood===v.factor && (this.p_y=i));
    //this.selectedItem.priority = `P${(priority_mtx[this.p_y]||[])[this.p_x]||0}`
  },
  methods:{
    speciality_name(id){ return (this.specialities.find(f=>f.id===id)||{}).name||''},
  }
};
</script>

<style scoped>
.sub_t{ margin-top:25px }
</style>
